import React, { useEffect, useState } from "react";
import {
  getLessonCurrentLevelCounts,
  getLessonFutureLevelCounts,
  getOverviewTexts,
  saveOverviewTexts,
} from "../../../lib/studentgparigorsummary";
import style from "./globalstudentgparigorsummary.module.css";
import { Toast, ToastContainer } from "react-bootstrap";

const levelClassMap = {
  AP: style.apCell,
  HR: style.hrCell,
  CC: style.ccCell,
  EA: style.eaCell,
  RG: style.rgCell,
};


export const getHeaderClass = (header) => {

  //if (isNaN(header)) return "";

  switch (header) {
    case "AP":
      return style.gpaBlue;

    case "CC":
      return style.gpaGreen;

    case "EA":
      return style.gpaOrange;
      
    case "HR":
      return style.gpaYellow;

    case "RG":
      return style.gpaLightRed;

    case "OT":
      return style.gpaRed;
      
      case "Overall":
        return style.totalCell;
    
      case "Ovr":
        return style.totalCell;

    default:
      return "";
  }
};


export const getColorClass = (value, type) => {
  const val = parseFloat(value);
  if (isNaN(val)) return "";

  switch (type) {
    case "gpa4":
      if (val >= 3.89) return style.gpaBlue;
      if (val >= 3.69) return style.gpaGreen;
      if (val >= 3.29) return style.gpaYellow;
      if (val >= 2.99) return style.gpaOrange;
      if (val >= 2.29) return style.gpaLightRed;
      return style.gpaRed;

    case "gpa10":
      if (val >= 9.0) return style.gpaBlue;
      if (val >= 8.0) return style.gpaGreen;
      if (val >= 6.5) return style.gpaYellow;
      if (val >= 5.0) return style.gpaOrange;
      if (val >= 3.5) return style.gpaLightRed;
      return style.gpaRed;
    // return console.log("red");

    case "percent":
      if (val >= 90) return style.gpaBlue;
      if (val >= 80) return style.gpaGreen;
      if (val >= 65) return style.gpaYellow;
      if (val >= 50) return style.gpaOrange;
      if (val >= 30) return style.gpaLightRed;
      return style.gpaRed;

    case "gpa5":
      if (val >= 4.5) return style.gpaBlue;
      if (val >= 4.0) return style.gpaGreen;
      if (val >= 3.5) return style.gpaYellow;
      if (val >= 3.0) return style.gpaOrange;
      if (val >= 2.0) return style.gpaLightRed;
      return style.gpaRed;

    default:
      return "";
  }
};

export default function GlobalStudentGpaRigorSummary({
  studentId,
  isStudent = false,
}) {
  const [current, setCurrent] = useState({});
  const [future, setFuture] = useState({});
  const [levels, setLevels] = useState([]);
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [collapseOpenClose, setCollapseOpenClose] = useState(true);

  const collapseAll = () => setCollapseOpenClose(!collapseOpenClose);

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const currentRes = await getLessonCurrentLevelCounts(studentId);
    const futureRes = await getLessonFutureLevelCounts(studentId);
    const overviewRes = await getOverviewTexts(studentId);

   
    
    const currentMap = {};
    const futureMap = {};
    const levelSet = new Set();

    currentRes.forEach((item) => {
      currentMap[item.level] = (currentMap[item.level] || 0) + item.count;
      levelSet.add(item.level);
    });

    futureRes.forEach((item) => {
      futureMap[item.level] = (futureMap[item.level] || 0) + item.count;
      levelSet.add(item.level);
    });

    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });

    setCurrent(currentMap);
    setFuture(futureMap);
    setOverview(overviewMap);
  // Custom sort order for levels
  const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => levelSet.has(lvl));
  setLevels(sortedLevels);
  };

  const handleOverviewChange = (type, value) => {
    setOverview((prev) => ({ ...prev, [type]: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, overview);
    showToastMessage("Update successful!");
    loadData();
  };

  const getTotal = (type) =>
    levels.reduce(
      (sum, level) =>
        sum +
        (type === "current"
          ? parseFloat(current[level] || 0)
          : parseFloat(future[level] || 0)),
      0
    );

  return (
    <div className="card p-3">
      <div className="personal-info-head">
        <h4>Course Load</h4>
        <ToastContainer
          style={{ top: "1rem", right: "1rem", position: "fixed" }}
          className="p-3"
        >
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <strong className="me-auto">Notification</strong>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowToast(false)}
              ></button>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      <div className={`collapse ${collapseOpenClose ? "show" : ""}`}>
       {/*} <h5 className="mb-3">Number of Courses</h5> {*/}
        <table className="table table-bordered text-center">
          <thead>
            <tr>
              <th style={{ width: "150px" }}></th>
              <th>Tot.</th>
              {levels.map((lvl) => (
                 <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
              ))}
              <th style={{ width: "400px" }}>Overview</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Current</td>
              <td className={`${style.totalCell}`}>{getTotal("current")}</td>
              {levels.map((lvl) => (
                <td
                  key={lvl}
                  className={current[lvl] > 0 ? getHeaderClass(lvl): ""}
                >
                  {current[lvl] ?? 0}
                </td>
              ))}
              <td rowSpan={3} className={style.overviewCell}>
                <div className="h-100 w-100 d-flex flex-column justify-content-between">
                  {!isStudent ? (
                    <textarea
                      rows={6}
                      className="form-control flex-grow-1"
                      style={{ resize: "none" }}
                      value={overview["clevel"] || ""}
                      onChange={(e) =>
                        handleOverviewChange("clevel", e.target.value)
                      }
                    />
                  ) : (
                    <div className="bg-light border rounded p-2 flex-grow-1 overflow-auto">
                      {overview["clevel"]}
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td>Future</td>
              <td className={`${style.totalCell}`}>{getTotal("future")}</td>
              {levels.map((lvl) => (
                <td key={lvl} 
                className={future[lvl] > 0 ? getHeaderClass(lvl): ""}>
                  {future[lvl] ?? 0}
                </td>
              ))}
            </tr>
            <tr>
              <td>Total</td>
              <td className={`${style.totalCell}`}>
                {getTotal("current") + getTotal("future")}
              </td>
              {levels.map((lvl) => (
                <td key={lvl} 
                 className={(((current[lvl] || 0) + (future[lvl]|| 0)) > 0 ? getHeaderClass(lvl): "" ) + " fw-bold"}>
                {/*className={getColorClass(((current[lvl] || 0) + (future[lvl] || 0)) / 2 ?? 0, "gpa10")}>*/}
                  {(current[lvl] || 0) + (future[lvl] || 0)}
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {!isStudent && (
          <div className="text-end">
            <button className="btn btn-primary" onClick={handleUpdate}>
              Update
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
